var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgTitle1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 377,
    zoomAndPan: "magnify",
    viewBox: "0 0 282.96 56.999996",
    height: 75,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "ae96a5bbb8"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b477c07a93"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 8.796875 L 282.921875 8.796875 L 282.921875 44.042969 L 0 44.042969 Z M 0 8.796875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3995b8aabd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 17.621094 8.796875 L 265.800781 8.796875 C 275.535156 8.796875 283.425781 16.6875 283.425781 26.417969 C 283.425781 36.152344 275.535156 44.042969 265.800781 44.042969 L 17.621094 44.042969 C 7.890625 44.042969 0 36.152344 0 26.417969 C 0 16.6875 7.890625 8.796875 17.621094 8.796875 Z M 17.621094 8.796875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.00476074,
    gradientTransform: "matrix(0.137677, 0, 0, 0.137677, -0.000655445, 8.796616)",
    y1: 128,
    x2: 2054.959103,
    gradientUnits: "userSpaceOnUse",
    y2: 128,
    id: "fcd05b24cc"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 19.198608%, 19.198608%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 19.345093%, 19.241333%)",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 19.639587%, 19.328308%)",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 19.934082%, 19.413757%)",
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 20.228577%, 19.499207%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 20.521545%, 19.584656%)",
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 20.81604%, 19.671631%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 21.110535%, 19.75708%)",
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 21.403503%, 19.842529%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 21.697998%, 19.927979%)",
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 21.992493%, 20.013428%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 22.285461%, 20.100403%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 22.579956%, 20.185852%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 22.874451%, 20.271301%)",
    offset: 0.101563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 23.167419%, 20.35675%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 23.461914%, 20.443726%)",
    offset: 0.117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 23.756409%, 20.529175%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 24.049377%, 20.614624%)",
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 24.343872%, 20.700073%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 24.638367%, 20.785522%)",
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 24.931335%, 20.872498%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 25.22583%, 20.957947%)",
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 25.520325%, 21.043396%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 25.813293%, 21.128845%)",
    offset: 0.179687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 26.107788%, 21.214294%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 26.402283%, 21.30127%)",
    offset: 0.195313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 26.695251%, 21.386719%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 26.989746%, 21.472168%)",
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 27.284241%, 21.557617%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 27.578735%, 21.644592%)",
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 27.871704%, 21.730042%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 28.166199%, 21.815491%)",
    offset: 0.242187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 28.460693%, 21.90094%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 28.753662%, 21.986389%)",
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 29.048157%, 22.073364%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 29.342651%, 22.158813%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 29.63562%, 22.244263%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 29.930115%, 22.329712%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 30.224609%, 22.416687%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 30.517578%, 22.502136%)",
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 30.812073%, 22.587585%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 31.106567%, 22.673035%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 31.399536%, 22.758484%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 31.694031%, 22.845459%)",
    offset: 0.335937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 31.988525%, 22.930908%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 32.281494%, 23.016357%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 32.575989%, 23.101807%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 32.870483%, 23.188782%)",
    offset: 0.367188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 33.163452%, 23.274231%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 33.457947%, 23.35968%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 33.752441%, 23.445129%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 34.04541%, 23.530579%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 34.339905%, 23.617554%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 34.634399%, 23.703003%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 34.928894%, 23.788452%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 35.221863%, 23.873901%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 35.516357%, 23.960876%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 35.810852%, 24.046326%)",
    offset: 0.445312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 36.103821%, 24.131775%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 36.398315%, 24.217224%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 36.69281%, 24.302673%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 36.985779%, 24.389648%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 37.280273%, 24.475098%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 37.574768%, 24.560547%)",
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 37.867737%, 24.645996%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 38.162231%, 24.731445%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 38.456726%, 24.81842%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 38.749695%, 24.90387%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 39.044189%, 24.989319%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 39.338684%, 25.074768%)",
    offset: 0.539063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 39.631653%, 25.161743%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 39.926147%, 25.247192%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 40.220642%, 25.332642%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 40.513611%, 25.418091%)",
    offset: 0.570313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 40.808105%, 25.50354%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 41.1026%, 25.590515%)",
    offset: 0.585937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 41.395569%, 25.675964%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 41.690063%, 25.761414%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 41.984558%, 25.846863%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 42.279053%, 25.933838%)",
    offset: 0.617187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 42.572021%, 26.019287%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 42.866516%, 26.104736%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 43.161011%, 26.190186%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 43.453979%, 26.275635%)",
    offset: 0.648437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 43.748474%, 26.36261%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 44.042969%, 26.448059%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 44.335938%, 26.533508%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 44.630432%, 26.618958%)",
    offset: 0.679687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 44.924927%, 26.705933%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 45.217896%, 26.791382%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 45.51239%, 26.876831%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 45.806885%, 26.96228%)",
    offset: 0.710937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 46.099854%, 27.047729%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 46.394348%, 27.134705%)",
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 46.688843%, 27.220154%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 46.981812%, 27.305603%)",
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 47.276306%, 27.391052%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 47.570801%, 27.478027%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 47.86377%, 27.563477%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 48.158264%, 27.648926%)",
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 48.452759%, 27.734375%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 48.747253%, 27.819824%)",
    offset: 0.789063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 49.040222%, 27.906799%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 49.334717%, 27.992249%)",
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 49.629211%, 28.077698%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 49.92218%, 28.163147%)",
    offset: 0.820313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 50.216675%, 28.250122%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 50.511169%, 28.335571%)",
    offset: 0.835938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 50.804138%, 28.421021%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 51.098633%, 28.50647%)",
    offset: 0.851563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 51.393127%, 28.591919%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 51.686096%, 28.678894%)",
    offset: 0.867187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 51.980591%, 28.764343%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 52.275085%, 28.849792%)",
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 52.568054%, 28.935242%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 52.862549%, 29.020691%)",
    offset: 0.898437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 53.157043%, 29.107666%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 53.450012%, 29.193115%)",
    offset: 0.914062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 53.744507%, 29.278564%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 54.039001%, 29.364014%)",
    offset: 0.929687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 54.33197%, 29.450989%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 54.626465%, 29.536438%)",
    offset: 0.945312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 54.920959%, 29.621887%)",
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 55.213928%, 29.707336%)",
    offset: 0.960937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 55.508423%, 29.792786%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 55.802917%, 29.879761%)",
    offset: 0.976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 56.097412%, 29.96521%)",
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 56.390381%, 30.050659%)",
    offset: 0.992188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 56.684875%, 30.136108%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("mask", {
    id: "0dd4c9e307"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#ae96a5bbb8)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -28.296,
    width: 339.552,
    fill: "#000000",
    y: -5.7,
    height: 68.399996,
    fillOpacity: 0.79
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "7e7f1fd3ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.5625 1 L 32 1 L 32 35.917969 L 0.5625 35.917969 Z M 0.5625 1 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b1dfd193d2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 27 1 L 59 1 L 59 35.917969 L 27 35.917969 Z M 27 1 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dcf43cff23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 53 1 L 84.550781 1 L 84.550781 35.917969 L 53 35.917969 Z M 53 1 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9b95aedc7b"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 86,
    y: 0,
    height: 36
  })), /*#__PURE__*/React.createElement("mask", {
    id: "53fe7f97c5"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#ae96a5bbb8)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -28.296,
    width: 339.552,
    fill: "#000000",
    y: -5.7,
    height: 68.399996,
    fillOpacity: 0.55
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "dc805e65c9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.804688 0.796875 L 33 0.796875 L 33 36 L 0.804688 36 Z M 0.804688 0.796875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9cc1b8ca35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 27 0.796875 L 59 0.796875 L 59 36 L 27 36 Z M 27 0.796875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "206f6e87e3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 54 0.796875 L 86 0.796875 L 86 36 L 54 36 Z M 54 0.796875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cd53698835"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 87,
    y: 0,
    height: 37
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b477c07a93)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3995b8aabd)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#fcd05b24cc)",
    d: "M 0 8.796875 L 0 44.042969 L 282.921875 44.042969 L 282.921875 8.796875 Z M 0 8.796875 ",
    fillRule: "nonzero"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#0dd4c9e307)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 44, 8)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9b95aedc7b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7e7f1fd3ff)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ee3838",
    d: "M 31.464844 18.414062 L 24.71875 11.625 L 24.679688 11.664062 L 14.0625 1.011719 L 0.5625 1.085938 L 17.929688 18.414062 L 0.5625 35.742188 L 14.0625 35.816406 L 24.679688 25.164062 L 24.71875 25.199219 Z M 31.464844 18.414062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b1dfd193d2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ee3838",
    d: "M 58.160156 18.414062 L 51.410156 11.625 L 51.371094 11.664062 L 40.757812 1.011719 L 27.296875 1.085938 L 44.625 18.414062 L 27.296875 35.742188 L 40.757812 35.816406 L 51.371094 25.164062 L 51.410156 25.199219 Z M 58.160156 18.414062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dcf43cff23)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ee3838",
    d: "M 84.890625 18.414062 L 78.105469 11.625 L 78.105469 11.664062 L 67.488281 1.011719 L 53.988281 1.085938 L 71.316406 18.414062 L 53.988281 35.742188 L 67.488281 35.816406 L 78.105469 25.164062 L 78.105469 25.199219 L 84.890625 18.414062 L 84.855469 18.414062 Z M 84.890625 18.414062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#53fe7f97c5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 172, 8)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cd53698835)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dc805e65c9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ee3838",
    d: "M 32.019531 18.417969 L 25.199219 11.5625 L 25.164062 11.601562 L 14.4375 0.839844 L 0.804688 0.914062 L 18.34375 18.417969 L 0.804688 35.921875 L 14.4375 36 L 25.164062 25.238281 L 25.199219 25.273438 Z M 32.019531 18.417969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9cc1b8ca35)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ee3838",
    d: "M 58.984375 18.417969 L 52.164062 11.5625 L 52.128906 11.601562 L 41.402344 0.839844 L 27.804688 0.914062 L 45.308594 18.417969 L 27.804688 35.921875 L 41.402344 36 L 52.128906 25.238281 L 52.164062 25.273438 Z M 58.984375 18.417969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#206f6e87e3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ee3838",
    d: "M 85.984375 18.417969 L 79.128906 11.5625 L 79.128906 11.601562 L 68.40625 0.839844 L 54.769531 0.914062 L 72.273438 18.417969 L 54.769531 35.921875 L 68.40625 36 L 79.128906 25.238281 L 79.128906 25.273438 L 85.984375 18.417969 L 85.949219 18.417969 Z M 85.984375 18.417969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgTitle1);
export default __webpack_public_path__ + "static/media/bg-title_1.ccce177c065711893d2d1b2d69148db8.svg";
export { ForwardRef as ReactComponent };